import React, {FormEvent} from 'react';
import {
  CreateUserPayload,
  PaginationResult,
  User,
  UserRole,
} from '../../dashboard/types';

interface UsersTabProps {
  newUser: CreateUserPayload;
  setNewUser: React.Dispatch<React.SetStateAction<CreateUserPayload>>;
  showCreateUserPassword: boolean;
  toggleCreateUserPassword: () => void;
  users: PaginationResult<User> | null;
  usersPage: number;
  setUsersPage: React.Dispatch<React.SetStateAction<number>>;
  handleCreateUser: (event: FormEvent) => void;
  loadUserDetail: (userId: string) => void;
}

export const UsersTab: React.FC<UsersTabProps> = ({
  newUser,
  setNewUser,
  showCreateUserPassword,
  toggleCreateUserPassword,
  users,
  usersPage,
  setUsersPage,
  handleCreateUser,
  loadUserDetail,
}) => {
  return (
      <section className='table-card'>
        <form
          className='create-user-form'
          onSubmit={handleCreateUser}>
          <div className='create-user-head'>
            <h2 className='create-user-title'>Add Team Member</h2>
            <p className='create-user-subtitle'>
              Create a new dashboard account and assign a role.
            </p>
          </div>
          <div className='create-user-grid'>
            <label className='create-user-field'>
              <span>Full Name</span>
              <input
                placeholder='e.g. Jane Doe'
                value={newUser.name}
                onChange={(e) =>
                  setNewUser((previous) => ({
                    ...previous,
                    name: e.target.value,
                  }))
                }
                required
              />
            </label>
            <label className='create-user-field'>
              <span>Email Address</span>
              <input
                type='email'
                placeholder='name@company.com'
                value={newUser.email}
                onChange={(e) =>
                  setNewUser((previous) => ({
                    ...previous,
                    email: e.target.value,
                  }))
                }
                required
              />
            </label>
            <label className='create-user-field'>
              <span>Temporary Password</span>
              <div className='create-user-password-wrap'>
                <input
                  type={showCreateUserPassword ? 'text' : 'password'}
                  placeholder='Set temporary password'
                  value={newUser.password}
                  onChange={(e) =>
                    setNewUser((previous) => ({
                      ...previous,
                      password: e.target.value,
                    }))
                  }
                  required
                />
                <button
                  type='button'
                  className='password-toggle-btn'
                  onClick={toggleCreateUserPassword}>
                  {showCreateUserPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </label>
            <label className='create-user-field'>
              <span>Role</span>
              <select
                value={newUser.role}
                onChange={(e) =>
                  setNewUser((previous) => ({
                    ...previous,
                    role: e.target.value as UserRole,
                  }))
                }>
                <option value='user'>user</option>
                <option value='manager'>manager</option>
                <option value='admin'>admin</option>
              </select>
            </label>
          </div>
          <div className='create-user-actions'>
            <button
              type='submit'
              className='create-user-primary'>
              Add User
            </button>
          </div>
        </form>
  
        <div className='table-wrap'>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Active</th>
                <th>Deleted</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users?.items.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>{user.isActive ? 'Yes' : 'No'}</td>
                  <td>{user.isDeleted ? 'Yes' : 'No'}</td>
                  <td>
                    <button
                      type='button'
                      onClick={() => loadUserDetail(user.id)}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
  
        <div className='pager'>
          <button
            disabled={!users?.hasPreviousPage}
            onClick={() => setUsersPage((p) => Math.max(1, p - 1))}>
            Previous
          </button>
          <span>
            Page {users?.currentPage || 1} of {users?.totalPages || 1}
          </span>
          <button
            disabled={!users?.hasNextPage}
            onClick={() => setUsersPage((p) => p + 1)}>
            Next
          </button>
        </div>
      </section>
    );
};
